import {createGlobalStyle} from "styled-components";

const NavigationStyle = createGlobalStyle`
    header{
        position: fixed;
        left: 50%;
        transform: translate(-50%, 0);
        top: 0;
        padding-top:20px;
        background: #000;
        z-index: 999;
    }
    p{
        color: #fff;
        margin: 0;
    }
    .nav-logo{
        z-index: 99;
        width: 70px;
    }
    .menu-icon{
        float: right;
        padding-top: 15px;
        padding-bottom: 15px;
        cursor: pointer;
        width: 90px;
    }
    .navbar-drawer{
        height: 100%;
        position: fixed;
        width: 100%;
        top: 0;
        background: #000;
        z-index: 999;
        transition: all 0.5s linear 0s;
        right: -100%;
            .rightNav {
                height: 100vh; 
                display: flex;
                position: relative;
                    .BannerImg{
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                    }
                    .closeImg{
                        width: 40px;
                        height: 40px;
                        position: absolute;
                        z-index: 10;
                        right: 42px;
                        top: 24px;
                        cursor: pointer;
                    }
            }
            .leftNav{
                height: 100vh;
                align-items: center;
                    .leftNavWrap{
                        padding-left: 100px;
                    }
                    .navDrawer-row{
                        margin-bottom: 20px;
                        cursor: pointer;
                        transition: opacity 1s ease-in-out;
                            p{
                                font-size: 36px;
                                font-weight: 600;
                                transform: translate(-30px);
                                transition: all 1s ease-in-out;
                            }
                            span{
                                color: #FF9F46;
                                text-transform: uppercase;
                            }
                            img{
                                opacity: 0;
                                transition: all 1s ease-in-out;
                            }
                            p:hover{
                                transform: translate(30px);
                                transition: all 1s ease-in-out;
                            }
                            p:hover >img{
                                opacity:1 !important;
                                transition: all 1s ease-in-out;
                            }
                            :hover{
                                filter: blur(0px)!important;
                            }
                    }
            }
    }
    @media only screen and (max-width: 992px) {
        .navbar-drawer .leftNav .leftNavWrap {
            padding-left: 30px;
        }
        .navbar-drawer .leftNav .navDrawer-row p {
            font-size: 25px;
        }
        .closeImg{
            position: absolute;
            top: 20px;
            right: 30px;
        }
    }
`;

export default NavigationStyle;
